export const locale = {
  lang: 'en',
  data: {
    'REQUERIMIENTOS': {
      'BOTONES':{
        'SIGUIENTE': 'Next',
        'ANTERIOR': 'Previous',
        'FINALIZAR': 'Finish',
        'ACEPTAR': 'I accept Technical Requirements'
      },
      'MENSAJES': {
        'CONFREQ': 'You have successfully accepted the platform technical requirements',
        'OK':'OK',
      },
      'CABECERA':{
        'TITULO': 'IT requirements',
        'DESCRIP': 'Lorem ipsum dolor sit amet, consectetur adipisicing elit,'
      },
      'PASO1':{
        'TITULO': 'Collaborator Requirements',
        'SUB_TITULO': '1. Application Requirements',
        'SUB_TITULO2': '2. Browser Capacity Requirements',
        'TABLE_REQUERIMIENTOS' : {
          'TD_SISTEMAS': 'Operating systems',
          'TD_LABEL_RECOMENDADO': 'or higher. (RECOMMENDED)',
          'TD_NAVEGADOR': 'Browser',
          'TD_LABEL_SUPERIOR': 'or higher',
          'TD_LABEL_LASTVERSION': '(last version)',
          'TD_LABEL_LASTVERSION_MIN': '(latest version, minimum version 12.3)'
        },
        'TABLE_REQUISITOS' : {
          'TD_CERTIFICAR': 'Security Certificate',
          'TD_COOKIES': 'Cookies allowed',
          'TD_CIFRADO': 'TLS encryption',

          'TD_CONTENT1': 'Make sure the security certificate or authority is granting Let’s Encrypt Authority X3 classified as reliable by your organization',
          'TD_CONTENT2': 'The browser must have JavaScript 1.2 enabled',
          'TD_CONTENT3': 'The CulturalGo Platform servers handle cookies, which do not collect information from the user or its operating system. But they are required for the operation of the survey and must be enabled.',
          'TD_CONTENT4': 'Depending on the type of project, one of our report modules requires only TLS encryption'
        },
        'PARRAFO1': {
          'SUBPARRAFO1': 'If the client intends to use other operating system such as LINUX, UNIX, ChromeOS or Mobile platforms, the client is responsible to ensure their browser software works well with the survey.',
          'SUBPARRAFO2': 'In response to the POODLE Vulnerability (CVE-2014-3566) and the termination of support for Windows XP by Microsoft, Great Place will no longer fully support access to our secured websites from computers running Windows XP. Great Place will maintain support for Windows XP computers using versions of Chrome or Firefox browsers listed in the application requirements. Access may still be available from other browsers; however, those browsers will not be tested or supported.'
        },
        'ADVERT': 'NOTE: As of version 5.0 of Cultural Go, support for Microsoft Internet Explorer is removed.'
      },
      'PASO2':{
        'TITULO': 'Survey authentication',
        'SUB_TITULO1': '3. Certificates',
        'SUB_TITULO2': '4. Collaborator´s laptop / computer',
        'SUB_TITULO3': '5. Survey response from mobile devices',
        'SUB_TITULO4': '1. Issues to consider',
        'SUB_TITULO5': '2. Language help',

        'PARRAFO1': 'Cultural GO uses Let’s Encrypt Authority X3 SSL Certificate provided by Internet Security Research Group (ISRG). If the certificate is not installed, a security warning page will be displayed to the user informing that there is a problem with the website’s security certificate. The user may either select to continue with accessing the website or to display more information about the issue. Even though the user is permitted to navigate the website, the warning message will continue to appear every time the user visits the site.',
        'PARRAFO2':{
          'LINEA1':'In order to access the online survey, the employee’s computer/ laptop needs:',
          'LINEA2':'Full access to the web address of the survey (Please make sure that the user has the proper permissions in case of having a firewall.)',
          'LINEA3':'In the event that the survey LINK is mailed, the user must have access to their corporate email account.',
        },
        'PARRAFO3': 'Surveys has been validated on mobile devices such as tablets and phones. Presentation and arrangement of survey elements will be matched to the resolution of the screen device. It depends on the model of the device for the survey to be executed.',

        'PARRAFO4': 'The survey has been designed to have a pleasant user experience on the vertical screens of mobile devices with Full HD Resolution.',

        'PARRAFO5': 'In several organizations, WiFi networks do not give full access to personal devices, so if the user decides to use their personal device and connect through a WiFi network, they must validate that they have access to the survey website.',

        'PARRAFO6': 'Users should take into account that if they use a direct connection to their cellphone company, navigation charges may apply.',
        'PARRAFO7':{
          'LINEA1':'Users will gain access to the site by using a specific URL that will be generated per project. Links do not have user’s information.',
          'LINEA2':'A unique user code must be entered into the secure global URL to enable survey access.',
          'LINEA3':'Every unique user code will be provided to users, either via email, SMS, or manually through Human Resources Manager (or equivalent position).',
        },
        'PARRAFO8':{
          'LINEA1':'1. The client needs to monitor the invitation delivery via email to their employees:',
          'LINEA2':'If email server is outsourced, please previously contact the email provider to inform the requirements.',
          'LINEA3':'If email server is in their facilities, ask for support from the IT department.',
          'LINEA4':'Note: In the sending of the invitations to answer the survey, no free service will be sent as: Hotmail, Gmail, Yahoo, etc.',
          'LINEA5':'2. If the client corporate email is OUTLOOK WEBACCESS, the employees will have to copy the web link and open it in the web browser, otherwise, it will generate an error.',
          'LINEA6':'3. Leaving the survey idle on the computer or device where the survey is being conducted for more than 30 minutes will generate a “TIME OUT”,having to re-register in the survey, with the same user and password. The System will take users to the exact question where they were',
          'LINEA7':'Each answer is saved when it is selected. User will not be able to select any other response until the saving process is complete, thus ensuring that the user´s progress in responding to the survey implies that all selected responses have been saved.',
        },
        'PARRAFO9':{
          'LINEA1':'Our survey supports only the languages set in the language selector and can only be selected at the beginning of the survey.',
          'LINEA2':'In case the selected languages are in any other language that requires special characters, the user must make sure that their browser supports the fonts.',
          'LINEA3':'Usually, all users intending to view the survey in any East Asian language or any other that requires special characters, already have language packs installed, so this may not be required to be done for all users except for a few.',
          'LINEA4':'For any project specific requirement to use a specific font on the online site, the users must have that specific font installed on each of their respective machines. Whenever required, Great Place will communicate such requirements to the client project team.',
        },
        'PARRAFO10': 'Important: The user must make sure that the browser does not have the automated translation function active, otherwise, the language selector may not work.',
      },
      'PASO3':{
        'TITULO': 'Internet connection requirements',
        'SUB_TITULO1': '1. SSL encryption requirements',
        'SUB_TITULO2': '2. Rbandwidth requirements',
        'SUB_TITULO3': '3. Firewall Whitelists: Web server IP and domain access',
        'SUB_TITULO4': '4. Firewall Whitelists: Email Server',
        'SUB_TITULO5': '5. Generation of Response Groups (Kioskos)',
        'PARRAFO1': 'The client web browser should support SSL enabled sites. This enables the user maximum privacy of personalized information.',

        'PARRAFO2': 'Bandwidth depends on the type of survey and reports being deployed and the components – video, flash, and images – used in the solution. For surveys with these components, the recommended connection is 1+ Mbit/s per user. Usability will be impacted if a lower connection is used. For surveys with none of these components, a normal connection to the internet is required.',

        'PARRAFO3':{
          'LINEA1':'The following should be white-listed for the survey and reporting sites to work on Cultural Go:',
          'LINEA2':'It is important to grant the necessary permissions to the following domains and IP addresses, in order to allow employees access to the Great Place to Work® Trust Index ©survey.',
        },
        'PARRAFO31': 'Important: The entire domain needs to be available for the users (must grant access to the entire site)',
        'PARRAFO4':{
          'LINEA1':'The mail server requires giving full access to the following email addresses:',
          'LINEA2':'It is necessary that the following are granted permissions on your mail server to avoid emails from Great Place to be classified as SPAM:',
        },
        'PARRAFO5':{
          'LINEA1':'Important:',
          'LINEA2':'This setup is to avoid the email address to be detected as SPAM ',
          'LINEA3':'The mail server has to be able to get thousands of emails from the same account',
          'LINEA4':'In the security rules of your email provider, add the domains for whitelisting, and if possible, add them as contact email accounts',
        },
        'PARRAFO6': 'In a great number of organizations, it is common to place several computers so that users can answer surveys in group. So it is necessary to do bandwidth tests of outputs to internet to ensure that the connection devices will support all traffic generated by response in groups.',
        'PARRAFO7': 'It is recommended that before users start answering in group, an IT area specialist verifies that there will be no internet connection problems.',
        'TABLA1':{
          'TD_ELEMENTO':'Element',
          'TD_REGION1':'Region México',
          'TD_REGION2':'Region Central and South America',
          'TD_REGION3':'Region Asia',
          'TD_REGION4':'Region Europe',
          'TD_DOMINIO':'Domain',
          'TD_SUBDOMINIO':'Sub-domain',
          'TD_DIRECCION':'IP Direction ',
          'TD_PUERTOS':'Ports',

        },
        'TABLA2':{
          'TD1':'Sender mail accounts:',
          'TD2':'Domain'
        },
        'TABLADOMINIO':{
          'TD_ELEMENTO01':'Application',
          'TD_ELEMENTO02':'Domain',
          'TD_ELEMENTO03':'IP',
          'TD_ELEMENTO04':'Port',
          'TD_ELEMENTO05':'Subdomain',
        },
        'TITLE1':'Domain: CulturalGo.com',
        'TITLE2':'Domain: gptw.global',
      },
      'PASO4':{
        'TITULO': 'Service levels',
        'SUB_TITULO1': '1. Support',
        'SUB_TITULO2': '2. System availability',
        'SUB_TITULO3': '3. Overwhelming force',
        'SUB_TITULO4': '4. Concurrence',
        'SUB_TITULO5': '5. Maintenance window',
        'TABLA1':{
          'TD_REGION1':'Region México',
          'TD_REGION2':'Region Central and South America',
          'TD_REGION3':'Region Asia',
          'TD_REGION4':'Region Europe'
        },
        'PARRAFO1':{
          'LINEA1':'Application availability = 99.5%',
          'LINEA2':'To ensure system availability, the application is monitored 24 hours by day 7 days of the week, 365 days of the year. With an alerting system and support procedures.',
        },
        'PARRAFO2': 'Force Majeure shall mean events beyond the reasonable control of a party including but not limited to, acts of God, war, strikes, government regulation, civil disturbances or acts of terrorism or earthquakes, that make it legally impracticable, illegal, or impossible for such party to perform its duties.',
        'PARRAFO3': 'The system availability service level does not cover any lack of service caused by the customer´s failure to meet the Technical Requirements set forth herein, or any event classified as Force Majeure',
        'PARRAFO4': 'The data collection environment can support 10,000 concurrent users or up to 1.5 million survey completes in a 24 hour period. The reporting application can support 500 concurrent users or up to 1,000 report sessions in a 24 hour period.',
        'PARRAFO5':{
          'LINEA1':'Great Place reserves the right to bring the survey and reporting application down for scheduled maintenance. Scheduled maintenance schedules will be communicated ahead of time to all affected parties.',
          'LINEA2':'During the above mentioned maintenance window, the application may not be available to users. If Great Place requires an extended maintenance window for additional activities, the designated client contact will be notified.',
          'LINEA3':'For emergency maintenance, the maintenance window may not be announced. For clients affected by the emergency affected maintenance, the designated client contact will be notified.'
        },
      },
      'PASO5':{
        'TITULO': 'Data privacy policy',
        'SUB_TITULO1': '1. Policy',
        'PARRAFO1': 'The information sent and stored in the servers of the CulturalGo Platform is protected and safeguarded under policies and procedures that comply with the provisions of ISO 27001. If you have any questions, please contact your Great Place To Work consultant.',
      },
      'VALIDACION':{
        'TITULO': 'Technical requirements validation',
        'DATOSTI':{
          'INFOEMPRESA': 'Company information',
          'NOMBREEMPRESA': 'Name of the company',
          'NOMBRE': 'IT manager name',
          'EMAIL': 'IT email',
          'TEL': 'IT phone number',
          'EXT': 'IT phone number extension',
          'CEL': 'IT mobile number',
          'TOOLTIP': 'Show company information',
        },
        'TIMELINE':{
          'TITULO': 'Technical requirements validation process',
          'CARGANDO': 'Loading information',
          'PROGRESO': 'Current progress:',
          'PROGRESO2': 'Technical requirements validation progress:',
          'STATUS': {
            'OK': 'Status: Completed',
            'NOTOK': 'Status: Not completed',
            'TOOLTIP': 'Mark as completed',
          },
          'COMENTARIO': {
            'TITULO_1': 'Save a comment about this step',
            'INPUT': 'Enter your comment',
            'ENVIAR': 'Save comment',
            'TITULO_2': 'Comments (oldest first)',
            'CANNOT': 'Comments cannot be submitted once the step is completed',
          },
          'NOMBRES': {
            '1': 'Email sent to TI manager',
            '2': 'TR Set up - Customer call',
            '3': 'TR Set up - Testing',
            '4': 'Question sheet sending',
            '5': 'Question sheet finished',
          }
        },
        'MENSAJES': {
          'NADA': 'You have not entered the comment yet, you may not save an empty comment',
          'AUNNO': 'You cannot do this action yet, the technical requirements validation must be completed first',
          'COMPLETAR': 'Do you confirm to change the state of this step as "completed"?',
          'COMPLETAR_OK': 'This step was changed to "Completed" successfully',
          'BOTONES': {
            'SI': 'Yes',
            'NO': 'No',
          },
          'NOCOMPLETAR': 'You may not mark this step as completed still, you must complete the previous step first',
        }
      }
    },
    'REQUERIMIENTOSV3':{
      'MENSAJES':{
        'MENSAJE_SUCCESS_OK':'Technical requirements updated',
        'MENSAJE_CONEX_OK':'Connection successful',
        'ACTUALIZANDO_REQUERIMIENTOS': 'Updating technical requirements',
        'MENSAJE_RESPUESTA_REQ':'* Response required',
        'WAR_ING_RUN': 'Enter at least one email',
      },
      'CABECERA':{
        'TITULO': 'Technical requirements',
        'DESCRIP': 'Lorem ipsum dolor sit amet, consectetur adipisicing elit,'
      },
       'BOTONES':{
              'SIGUIENTE': 'Next',
              'ANTERIOR': 'Previous',
              'FINALIZAR': 'Finish',
              'ACEPTAR': 'I accept the technical requirements '
            },
        'PASO1':{
          'TITULO':'Contributor requirements',
          'SUB_TITULO':'Technical Requirements',
          'SUB_TITULO2':'CulturalGo® Platform 5.0',
          'TEXTO0_PARTE_1':'he purpose of this document is to inform about the technical requirements of the CulturalGo® platform in order to guarantee an easy and effective access to the Greate Place to Work®, Trust Index© survey system and thus avoid recurrent technical problems.',
          'TEXTO0_PARTE_2':'It is essential to comply with and verify each of the technical requirements for your organizations collaborators to receive and respond to the survey. Otherwise, it is very likely that there will be complications such as blockages and/or interfaces that result in the collaborator not being able to receive and respond to the survey.',
          'SUB_TITULO3':'Contributor (End User) Requirements',
          'SUB_TITULO4':'Application Requirements',

          'SUB_TITULO2_CARCA':'Cultural Go® Platform 5.0',
          'TEXTO0_PARTE_1_CARCA':'The purpose of this document is to inform about the technical requirements of the CulturalGo® platform in order to guarantee an easy and effective access to the Great Place to Work®, Trust Index© survey system and thus avoid recurrent technical problems.',
          'TEXTO0_PARTE_2_CARCA':'It is essential to comply with and verify each of the technical requirements for your organizations collaborators to receive and respond the survey. Otherwise, it is very likely that there will be complications such as blockages and/or interfaces that result in the collaborator not being able to receive and respond the survey.',
          'TEXTO0_PARTE_1_INNMO':'The purpose of this document is to inform about the technical requirements of the CulturalGo® platform in order to guarantee an easy and effective access to the Innmotion, Trust Index© survey system and thus avoid recurrent technical problems.',

          'TABLE_REQUERIMIENTOS' : {
            'TD_SISTEMAS': 'Operating systems:',
            'TD_LABEL_RECOMENDADO': 'or higher (RECOMMENDED)',
            'TD_NAVEGADOR': 'Browser: ',
            'TD_LABEL_SUPERIOR': 'or higher.',
            'TD_LABEL_LASTVERSION': '(last version).',
            'TD_LABEL_LASTVERSION_MIN': '(last version, minimum version 12.3).'
          },
          'TEXTO1_PARTE_1':'If the customer intends to use another operating system other than those listed above such as versions of LINUX, UNIX, Chrome OS, mobile operating systems, etc., the customer is responsible for ensuring that the survey runs correctly on their browser software.',
          'TEXTO1_PARTE_2':'Due to the vulnerability of POODLE (CVE-2014-3566) and the termination of Windows XP support by Microsoft, Great Place to Work® will no longer support access to our secure websites from computers running Windows XP. Great Place to Work® will maintain support for computers running Windows XP using versions of the Chrome or Firefox browsers listed in the application requirements. Access may still be available from other browsers; however, those browsers will not be tested or supported.',
          'TEXTO1_PARTE_2_INNO':'Due to the vulnerability of POODLE (CVE-2014-3566) and the termination of Windows XP support by Microsoft, Innmotion will no longer support access to our secure websites from computers running Windows XP. Innmotion will maintain support for computers running Windows XP using versions of the Chrome or Firefox browsers listed in the application requirements. Access may still be available from other browsers; however, those browsers will not be tested or supported.',
          'TEXTO2_PARTE_1':'Note: Starting with version 5.0 CuturalGo®, support for Microsoft Internet Explorer will be removed',
        },
        'PASO2':{
          'TITULO': 'Survey authentication',
          'SUB_TITULO1': 'Web server IP and domain access',
          'SUB_TITULO2': 'Firewall Whitelists:',
          'TEXTO0_PARTE_1': 'The following must appear on the whitelists for survey and report sites to work on The Cultural Go® Platform:',
          'TEXTO1_PARTE_1': 'It is important to grant the necessary permissions to the following domains and IP address to allow your employees to access the Great Place to Work® Trust Index© survey',
          'TEXTO1_PARTE_1_INNMO': 'It is important to grant the necessary permissions to the following domains and IP address to allow your employees to access the Innmotion Trust Index© survey',
          'BTN_COMPRO_CONEX':'Check connection',
          'BTN_SUCCE_CONEX':'Connection established',
          'TOOL_BTN_COMPRO_CONEX':'Service under construction',
          'MODAL_SUCCESS_CONEX':'The connection was successful',
          'ETI_INTRUC_DOMA_COPY':'Copy and send this link in case you need to verify connections from any decentralized access point (Does not impact the validation of Technical Requirements).',
          'BTN_INTRUC_COPY_ENLA':'Copy link',
          'MODAL_COPY_ENLA_SUCC':'Link was copied successfully',

          'SUB_TITULO2_CARCA': 'Firewall whilelists:',
          'TEXTO0_PARTE_1_CARCA': 'The following must appear on the whitelists for survey and report sites to work on The Cultural Go® Platform:',
          'TEXTO1_PARTE_1_CARCA': 'It is important to grant the necessary permissions to the following domains and IP address to allow your employees to access the Great Place to Work® Trust Index© survey',

          'TABLE_CONTEN':{
           'TH_ELEMENTO':'Element',
           'TH_REGIONM':'Global Region',
           'TH_REGIONC':'Central and South America Region',
           'TH_REGIONA':'Asia Region',
           'TH_REGIONE':'Europe Region',
           'TH_DOMINIO_PRINCIPAL':'Main Domain',
           'TH_APLICADOR':'Survey Applicator',
           'TH_PLATAFORMA':'Administration Platform',
           'TH_ENVOLTURA':'Url Wrap',
           'TH_RESULTADOS':'Results (Tableau®)',
           'TH_CULTURE':'Culture Audit®',
           'TH_PORTAL':'External counting portal',
           'TH_SUBDOMINIO':'Subdomain',
           'TH_DIRECCION_IP':'IP Address',
           'TH_PUERTOS':'Ports',
           'TH_DOMINIO':'Domain',
           'TEXTO1':'• All the links to the surveys will be delivered through the URL wrapper 4all.gptw.global/ , which contains a redirection to the site ﬁnal of the survey assigned for each company. ',
           'TEXTO2':'• For security reasons, CulturalGo®s algorithms may change the URL of the ﬁnal survey at any time during the survey period. Therefore, the 4all.gptw.global/ wrapper must always be used, which is permanent throughout the survey.',
           'TEXTO3':' IMPORTANT:',
           'TEXTO4':' The survey link should never be accessed directly (e.g., http://newsurvey.culturalgo.com/Ax013s203ls) as the token that makes up the survey may change from time to time without notice.',
           'TEXTO5':' Important :',
           'TEXTO6':' Users must have full and unlimited (unrestricted) access to the entire domain. ',
           'TEXTO7':' e-mail server',
           'TEXTO8':' The mail server requires full access to the following email addresses:',
           'TEXTO9':' The following permissions are required on your mail server to prevent Great Place to Work® emails from being sent to clasiﬁquen as SPAM:',
           'TEXTO9_INNMO':' The following permissions are required on your mail server to prevent Innmotion emails from being sent to clasiﬁquen as SPAM:',
           'TABLA_CONTENT2':{
             'TD_CUENTA_CORREO':' Senders email account:',
             'TD_DOMINIO':' Domain:',
             'TD_IP_ADDRE_PRIM':'Primary IP address:',
             'TD_SECON_IP':'Secondary IP addresses:',
             'TD_SUBDOMINIO':'Subdomains for redirection of links (They are used for monitoring):',
           },
           'TEXTO10':'•	This conﬁguración is to prevent the email address from being detected as spam. ',
           'TEXTO11':'•	The mail server must be able to receive thousands of emails from the same account.',
           'TEXTO12':'•	In the security rules of your email provider, add the domains for the whitelist and, if possible, add them as contact email accounts',
           'TEXTO13':'If you require support send a message to',
           'BTN_CONFIGURACION':'Domains and IPs were configured',
           'BTN_ACCESO_ENCUESTA':'I performed the tests and had no complications',
           'BTN_RECIBI_CORREOS':'I received the emails in my inbox',

          }
        },
        'PASO3':{
          'TITULO':'Access tests',
          'TIT_TES_PRU_ACC_SURV': 'In this section you will be able to carry out a visualization test of a generic survey (unrelated to your organizations):',
          'INS2_TES_PRU_ACC_SURV':'1. Click on:',
          'INS1_1_TES_PRU_ACC_SURV':'Copy key:',
          'INS1_TES_PRU_ACC_SURV':'2. Access the following link:',
          'INS3_TES_PRU_ACC_SURV':'3. Paste the key into the password cell',
          'INS4_TES_PRU_ACC_SURV':'4. Click on login',

          'TIT_TES_PRU_EM_PILO': 'In this section you will be able to make a test of reception of the mail',
          'INS1_TES_PRU_EM_PILO':'1. Enter the emails',
          'INS2_TES_PRU_EM_PILO':'2. Click on the "Send Test Mail" button',
          'BTN_SE_EMA': 'Sending the test mail',
          'CONTAC':'In case of technical errors please contact us at support@itbm.mx and we will be glad to solve it.',
          'WARN_TEST_EMAIL':'To continue with the process we have sent you a confirmation link to your email address',
          'MSJ_SUCC_EMA_': 'Emails were successfully sent',
          'MODAL_WARNI_BAND':'To continue with the process confirm access to the survey and/or receipt of the e-mail',
          'MODAL_VERIFI_INFO':'Verifying information',
          'MSJ_COP_CLA': 'Copying user key',

          'MODAL_WARNI_EMAL':'IMPORTANT: This link should not be shared with the employees of the organization, because it is a test link in order to validate that the necessary permissions have been granted at the opening of the survey.',
          'CONTAC_CARCA':'In case of technical errors please contact us at soporte_ca@gptwonline.com and we will be glad to solve it.',
          'WARN_TEST_EMAIL_CARCA':'To continue with the process we have sent you a confirmation link to your email address',
        },
        'PASO4':{
          'TITULO':'Validation questionnaire',
          'PREGUNTAS':{
            'PREGUNTA_1':'1.-¿Do I make the settings without any problem?',
            'PREGUNTA_1_INDI':'(If you have had any problems please specify)',
            'PREGUNTA_2':'2.-Your mail server was trusted by::',
            'PREGUNTA_2_INDI1':'a) Your Internal IT team( has full control of the Configurations).',
            'PREGUNTA_2_INDI2':'b) I request a ticket from your provider (mention the name of the provider)',
            'PREGUNTA_3':'3.-¿Your emails are under business accounts (Gmail, Microsoft, Yahoo!, etc.)?',
            'PREGUNTA_4':'4.-¿Did you register the domain gptwonline.com, remember that the emails you receive are from this domain, ensure that they have not gone to spam or junk mail?',
            'PREGUNTA_5':'5.-¿Do you have a way to obtain a list of received emails (Email log)?',
            'PREGUNTA_6':'6.-¿What internet browsers do your collaborators have installed? (Please list; Browser - version)',
            'PREGUNTA_7':'7.-¿Did you grant the necessary permissions for your employees to navigate the survey? (If I present a problem please specify)',
            'PREGUNTA_8':'8.-¿For the application of your survey do you have computer rooms planned for your employees to answer your survey?',
            'PREGUNTA_8_INDI1':'(¿(If yes, please indicate the number of rooms and the number of equipment per room?)',
          },
          'BTN_VALIDAR_ENVIAR':'Validate and send',
        },
        'PASO5':{
          'TITULO': 'Data privacy policy',
          'SUB_TITULO':'Data Privacy Policy',
          'PARRAFO1': 'The information sent and stored on the servers of the CULTURAL GO® Platform is protected and safeguarded under policies and procedures that comply with ISO 27001. If you have any questions about this, please contact your Great Place To Work® consultant',
          'PARRAFO1_INNMO': 'The information sent and stored on the servers of the CULTURAL GO® Platform is protected and safeguarded under policies and procedures that comply with ISO 27001. If you have any questions about this, please contact your Innmotion consultant',
          'PARRAFO2':'Registered Trademarks',
          'PARRAFO3_1':'•	Great Place to Work® y Trust Index© ',
          'PARRAFO3_2':'are registered trademarks of Great Place To Work Institute USA, in this document these marks are only used as reference.',
          'PARRAFO3_1_INNMO':'•	Innmotion y Trust Index© ',
          'PARRAFO3_2_INNMO':'are registered trademarks of Innmotion Institute USA, in this document these marks are only used as reference.',
          'PARRAFO4_1':'•	Cultural Go®, SuccessGo® ',
          // 'PARRAFO4_2':'It is a registered trademark by Innovación Tecnológica B&M S.A. de C.V. Mexico',
          'PARRAFO4_2':' and in general the entire Go!® platform are registered trademarks of the developer.',
          'PARRAFO5':'Thank you!!',
          'BTN_FINALIZAR':'Finish and Send',
          'BTN_FINA_REQUE': 'Finished Technical Requirements',


        },
        'COPY_MESSAGE':'Key copied to the clipboard',
        'COMPR_CONEXI':'Checking the connection',
        'SUCCES_CONF_EMA':{
        'MODAL_SUCCESS':'Mail reception has been validated',
        'MODAL_INSTRUCCI':'Please close the tab',
        },
        'FORMULARIO_TI': {
          'TAB': 'End of the process',
          'TITULO': 'Reviewer details',
          'SUBTITULO': 'To conclude the process, enter your data in the following form and click the Finish button',
          'DONE': 'The process has already finished',
          'FINALIZAR': 'Finalize technical requirements',
          'NOTYET': 'The IT manager has not completed the process, he will be able to confirm the technical requirements until the IT manager has entered their data',
          'FORM': {
            'NOMBRE': 'Name',
            'MAIL': 'Email',
            'FECHA': 'Finish date',
            'SINENVIAR': 'Data not yet sent'
          },
          'MENSAJES': {
            'NOMBRE': 'You have not entered your name in the indicated field',
            'GUARDANDO': 'The information you entered is being saved, please wait a moment',
            'GUARDADO': 'The data was saved correctly'
          }
        },
          'ETI_EMPRE':'Company:',
          'CONTAC':'Contact us:',
        'CONTAC_DES':'How can we help you?',
        'SEND_EMA':'Send a message',
        'LABEL':'Description',
        'TEX_BTN_SEND':'Send',
        'MODA_SEN_EMAI':'Sending message...',
        'SUCC_MODA_SEN_EMAI':'The message was sent successfully ',

    }
  }
};
